import { faX } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useUserStorage } from '../../../storage/user'
import linkEmbed, { getAllCursosMatriculados } from '../../../utils'
import { concluirAula, getAllCursosEstudante } from '../../../Api'
import { useNavigate } from 'react-router-dom'
import './styles.css'
import { useCursosStorage } from '../../../storage/cursos'
import { notify } from '../../../components/Notify'
export default function VideoAula() {

    const navigate = useNavigate();

    const { selectedAula, selectedCurso } = useCursosStorage(state => state).dados
    const { setSelectedCurso, setSelectedAula } = useCursosStorage(state => state).dispatch

    const [yout, setYout] = useState('')

    useEffect(() => {
        const link = linkEmbed(selectedAula?.video)
        setYout(link)
    }, [selectedAula])

    const concluirAulaf = () => {
        concluirAula({aulaId: selectedAula.id, userId: localStorage.getItem("id")}).then(res => {

            const { setCursosDoEstudante } = useCursosStorage.getState().dispatch

            if (localStorage.getItem("tipo") == 'ALUNO' || localStorage.getItem("tipo") == 'ESTUDANTE'){

            
            getAllCursosEstudante({id:localStorage.getItem("id")}).then(response => { 
                notify('Aula concluída com sucesso!')
                /*  const stringObjCursos = JSON.stringify(response.data);
                 localStorage.setItem("cursosEstudante", stringObjCursos); */
                setCursosDoEstudante(response.data)


                const cursos = response.data
                var currentC = cursos.filter(item => {
                    if (item.id == selectedCurso.id) {
                        return item
                    }
                })

                setSelectedCurso(currentC[0])
                setSelectedAula({...selectedAula, assistido: true})
            })}

        })
    }

    return (
        <div style={{ width: '100%' }}>
            <div style={{ background: '#3E64DE', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 20px' }}>
                <h4 style={{ color: '#fff' }}>
                    {selectedAula?.titulo}
                </h4>
                <div>
                    {!selectedAula.assistido &&  <button className='concluiraula' onClick={concluirAulaf}>Marcar como concluído</button> }
                   
                    <FontAwesomeIcon onClick={() => { navigate('/painel') }} style={{ cursor: 'pointer' }} color='#fff' icon={faX} size='1x' />
                </div>
            </div>
            <iframe style={{ width: '100%', aspectRatio: '13/7' }}
                src={yout}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen></iframe>
        </div>
    )
}
